/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_TitleInputs */

const en_control_faq_title = /** @type {(inputs: Control_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you head back in`)
};

const zh_control_faq_title = /** @type {(inputs: Control_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

/**
* | output |
* | --- |
* | "Before you head back in" |
*
* @param {Control_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_title = /** @type {((inputs?: Control_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_title(inputs)
	return zh_control_faq_title(inputs)
});
export { control_faq_title as "control.faq.title" }